import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NgxJdenticonModule } from 'ngx-jdenticon';
import { ClickOutside } from '../../shared/directives/click-outside';
import {
  GlobalPositionStrategy,
  Overlay,
  OverlayRef,
} from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Subject, takeUntil } from 'rxjs';
import { ProfileService } from '../../core/profile.service';
import { UserProfile } from '../../core/interfaces';
import { ThemeSwitcherComponent } from '../../shared/components/theme-switcher/theme-switcher.component';

@Component({
  selector: 'app-user-dropdown',
  imports: [NgxJdenticonModule, ClickOutside, ThemeSwitcherComponent],
  templateUrl: './user-dropdown.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-dropdown.scss',
})
export class UserDropdown implements OnInit, OnDestroy {
  private service: ProfileService = inject(ProfileService);
  isImpersonating = false;
  isDropdownOpen = false;
  private overlay: Overlay = inject(Overlay);
  private overlayRef: OverlayRef | null = null;
  currentUser!: UserProfile;

  private destroy$ = new Subject<void>();

  get isAdmin(): boolean {
    return ['root', 'admin'].includes(this.currentUser.group);
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  closeDropdown() {
    this.isDropdownOpen = false;
  }

  ngOnInit(): void {
    /*this.service.isImpersonating$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isImpersonating) => {
        this.isImpersonating = isImpersonating;
      });*/

    this.service.userprofile$
      .pipe(takeUntil(this.destroy$))
      .subscribe((curUser) => {
        if (curUser) {
          this.currentUser = curUser;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  switchProfile() {
    if (this.overlayRef) {
      return;
    }

    const positionStrategy: GlobalPositionStrategy = this.overlay
      .position()
      .global()
      .centerVertically()
      .centerHorizontally();

    const config = {
      positionStrategy: positionStrategy,
      hasBackdrop: true,
      backdropClass: 'modal-backdrop',
      panelClass: 'modal-container',
    };

    /*this.overlayRef = this.overlay.create(config);
    const profileSwitcher = new ComponentPortal(ProfileSwitcher);
    const componentRef = this.overlayRef.attach(profileSwitcher);
    componentRef.instance.overlayRef = this.overlayRef;

    componentRef.instance.closeOverlay.subscribe((_) => {
      this.closeOverlay();
    });

    this.overlayRef.backdropClick().subscribe(() => {
      this.closeOverlay();
    });*/
  }

  stopImpersonating(): void {
    // this.service.stopImpersonating();
  }

  logout() {
    this.service.logout();
  }

  closeOverlay() {
    this.overlayRef?.dispose();
    this.overlayRef = null;
  }
}
